import UI from "/javascripts/utils/UI";
import bus from "/javascripts/bus";

UI(
  {
    component: ".js-SplitHeader",
    toggleMenu: ".js-SplitHeader-toggleMenu",
    contactCta: ".js-SplitHeader-contactCta",
    bars: [".js-SplitHeader-toggleMenuBar"],
  },
  async ({
    component,
    toggleMenu,
    contactCta,
    bars,
  }) => {
    await import("gsap/CSSPlugin");
    const TimelineLite = await import("gsap/TimelineLite").then(
      (gsap) => gsap.TimelineLite
    );
    const state = {
      isMenuOpen: false,
      previousIsLightState: null,
      timeline: createTimeLine(),
      hash: null,
    };

    if (component.classList.contains("is-light")) {
      bus.on("onUpdateScrollFromTop", onUpdateScrollFromTop);
    }

    bus.on("updateSplitHeader", onUpdateSplitHeader);
    bus.on("onToggleHeader", onToggleHeader);
    bus.on("closeMenu", doCloseMenu);
    bus.on("menuAfterClose", doMenuAfterClose);

    toggleMenu.addEventListener("click", doToggleMenu);

    function doCloseMenu(hash) {
      doToggleMenu(false);
      state.hash = hash;
    }

    function doMenuAfterClose() {
      window.location.hash = state.hash;
    }

    function doToggleMenu(evt, callback) {
      if (evt) evt.preventDefault();
      toggleMenu.blur();
      state.isMenuOpen = !state.isMenuOpen;
      bus.emit("toggleMenu", state.isMenuOpen);
      component.classList.toggle("is-open", state.isMenuOpen);
      if (state.isMenuOpen) {
        state.timeline.play();
        state.isLightDesired = component.classList.contains("is-light");
        state.isContactCtaDesired = !contactCta.classList.contains("is-hidden");
        component.classList.remove("is-light");
        contactCta.classList.add("is-hidden");
      } else {
        state.timeline.reverse();
        component.classList.toggle("is-light", state.isLightDesired);
        contactCta.classList.toggle("is-hidden", !state.isContactCtaDesired);
      }
      if (typeof callback === "function") callback();
    }

    function createTimeLine() {
      const tl = new TimelineLite({ paused: true });
      tl.to(
        bars[0],
        0.225,
        { transformOrigin: "right center", rotation: "-45deg", scaleX: 1.1 },
        "0"
      );
      tl.to(
        bars[1],
        0.225,
        { transformOrigin: "right center", rotation: "45deg", scaleX: 1.1 },
        "0"
      );
      tl.to(bars[2], 0.225, { opacity: 0 }, "0");
      return tl;
    }

    function onUpdateScrollFromTop({ boundingClientRect }) {
      const { y: currentPosition } = boundingClientRect;
      const minTriggerPosition = component.clientHeight / 2;
      toggleIsLightSplitHeader(currentPosition > minTriggerPosition);
    }

    function onUpdateSplitHeader({ isLight, showContactCta }) {
      toggleIsLightSplitHeader(isLight);
      contactCta.classList.toggle("is-hidden", !showContactCta);
    }

    function toggleIsLightSplitHeader(isLight) {
      if (state.previousIsLightState === isLight) {
        return;
      }

      state.previousIsLightState = isLight;
      component.classList.toggle("is-light", isLight);
    }

    function onToggleHeader(isOpen) {
      component.classList.toggle("is-hiding", isOpen);
    }
  }
);
